import type { OrdersAutoDeclineSuccess } from '~/services/api/generated'
import { normalizeOrderDetail } from './normalizeOrderDetail'

/**
 * `POST dashboard/orders/{order_number}/auto-decline` answers with the shared
 * `jsonSuccess` envelope, so the order sits at `data.order` — not at `data`.
 */
export const normalizeAutoDeclineResponse = (response: OrdersAutoDeclineSuccess) => {
  return {
    success: response.success,
    message: response.message,
    data: normalizeOrderDetail(response.data.order)
  }
}
